RivalIQ.apps.Discovery.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, moment) {

    'use strict';

    const MAX_BODY_LENGTH = 150;

    const PostTableCell = Marionette.LayoutView.extend({
        tagName: 'td',
        className: 'post-overview discovery-post-table-cell',
        template: '#discoveryPostTableCellTemplate',

        regions: {
            description: '.x-linkified-text'
        },

        onRender: function () {
            const me = this;
            me.showLinkifiedText();
        },

        showLinkifiedText: function () {
            const me = this;

            const post = _.last(me.getOption('data'));

            me.description.show(new App.views.LinkifiedText({
                model: me.model,
                data: {
                    text: _.get(post, ['attributes', 'rivaliq', 'display', 'message']),
                    urls: _.get(post, ['attributes', 'extractedUrls'])
                }
            }));
        },

        serializeData: function () {
            const me = this;

            const post = _.last(me.getOption('data')).toJSON();
            const channel = me.model.get('channel');

            const dashboardModel = me.getOption('table').dashboardModel;
            const channelName = RivalIQ.data.channels.get(dashboardModel.getProp('channel')).get('name');

            post.user.verified = post.user.verified || null;

            const useCdnThumbnail = RivalIQ.apps.SocialPosts.utils.shouldUseCdnThumbnail(post.useThumbnailUrl, post.image);

            return _.extend({
                maxBodyLength: MAX_BODY_LENGTH,
                following: false,
                channelName: channelName,
                image: _.get(post, ['rivaliq', 'display', 'image'], null),
                video: RivalIQ.apps.SocialPosts.utils.makePreviewVideoUrl(_.get(post, ['rivaliq', 'display', 'video'], null)),
                postLink: null,
                isExporting: dashboardModel.isExporting(),
                useCdnThumbnail: useCdnThumbnail
            }, App.utils.generateProfileLinks(post.user.handle, channel), post);
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    App.views.LinkifiedText = Marionette.ItemView.extend({
        template: '#discoveryFilterableDescriptionTemplate',

        serializeData: function () {
            const me = this;
            const data = me.getOption('data');
            return {
                htmlText: me.linkifyText(data)
            };
        },

        linkifyText: function (data) {
            // make sure text is sanitized in preparation for emojify
            const text = _.escape(data.text);
            const shortText = _.truncate(text, MAX_BODY_LENGTH);
            const urls = data.urls;

            const processedUrls = _.map(urls, function (url) {
                const start = text.indexOf(url);
                const end = start + url.length;
                const href = text.substring(start, end);
                return {
                    html: $.tagHtml('a', {
                        text: shortText.substring(start, end),
                        class: 'link-muted',
                        target: '_blank',
                        // make sure the href doesn't just get appended to current window location
                        href: !(_.startsWith(href, 'https://') || _.startsWith(href, 'http://')) ? `http://${href}` : href
                    }),
                    start: start,
                    end: end
                };
            });

            // continually replace the url with its html
            let linkifiedText = shortText;
            _.forEach(processedUrls, function (url) {
                const offsetFromOriginal = linkifiedText.length - shortText.length;
                const start = url.start + offsetFromOriginal;
                const end = url.end + offsetFromOriginal;
                linkifiedText = s.splice(linkifiedText, start, end - start, url.html);
            });

            return _.unescape(RivalIQ.utils.emoji.emojify(linkifiedText));
        }
    });

    const TableView = RivalIQ.apps.Dashboard.widgets.MetricTable.mixin({
        mixins: {
            LoadDataWithBuffering: RivalIQ.apps.Dashboard.mixins.LoadDataWithBuffering
        },

        ui: _.defaults({
            influencer: '.author-name',
            actionsPopover: '.x-actions-popover',
            tooltips: '[data-toggle="tooltip"]'
        }, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.ui),

        _loadData: RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData,

        onRender: function () {
            const me = this;
            me.ui.tooltips.tooltip();

            const influencers = _.reduce(me.rows, function (memo, row) {
                // This magic works as the first column is the full post object.
                const user = _.get(row, [1, 1, 'attributes', 'user']);

                if (user) {
                    memo[user.handle] = user;
                }

                return memo;
            }, {});

            App.views.InfluencerPopover.addPopovers(me, me.ui.influencer, influencers, true);
        },

        onAttachLoaded: function () {
            const me = this;

            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.onAttachLoaded.apply(me, arguments);

            RivalIQ.apps.SocialPosts.utils.attachVideoOnLoadHandlers(me.$el);
        },

        getFetchAttributes: function () {
            const me = this;

            const orderBy = me.getProp('orderBy');
            me.sortColumns = App.utils.getColumnSortOrder(me.metricsCollection, orderBy);

            return {
                limit: Number(me.getProp('limit') || 0),
                sortOrder: Number(me.getProp('sortOrder') || 1),
                orderBy: App.utils.getOrderByString(me.sortColumns, me.metricsCollection)
            };
        },

        rowClassName: function () {
            const me = this;
            return (me.getProp('noClickThrough') ? '' : 'pointer');
        },

        onRowClick: function (data, e) {
            const me = this;

            const target = $(e.target);

            // Links should not pop the modal
            if (target.is('a') || me.getProp('noClickThrough')) {
                return;
            }

            // grab the current post model
            let postModel = _.last(data[0]);
            if ((me.getProp('channel') === RivalIQ.enums.channels.TWITTER) || me.getProp('searchType') === App.enums.searchTypes.PROFILE) {
                postModel = _.last(data[1]);
            }

            let sliceStart = 1;
            let sliceEnd = me.dashboardModel.metricsCollection.length;
            if (me.getProp('channel') === RivalIQ.enums.channels.TWITTER) {
                sliceStart = 2;
                // we don't want sentiment for twitter
                sliceEnd = sliceEnd - 1;
            } else if (me.getProp('searchType') === App.enums.searchTypes.PROFILE) {
                sliceStart = 2;
            }

            RivalIQ.execute('show:modal', {
                size: 'large',
                className: 'post-modal',
                information: {
                    title: 'Post Details',
                    content: RivalIQ.strings.social_post_details_info
                },
                contentView: new App.views.PostDetails({
                    model: postModel,
                    // we don't want sentiment
                    postDetailMetrics: _.map(_.slice(me.dashboardModel.metricsCollection.models, sliceStart, sliceEnd), 'attributes'),
                    channel: me.getProp('channel')
                })
            });
        }
    });

    const DiscoveryPostGridItem = RivalIQ.views.SocialPostGridItem.extend({
        template: '#discoveryPostGridItemTemplate',
        ui: _.defaults({
            noImageMsg: '.no-image-message'
        }, RivalIQ.views.SocialPostGridItem.prototype.ui),

        onAttach: function () {
            const me = this;
            const postGridItem = $('.social-post-grid-item');

            // hack my way to vertically centering the text
            if (me.dashboardModel.curation.isExporting() && !parseInt(postGridItem.css('padding-top'))) {
                const topPadding = (postGridItem.height() - parseInt(me.ui.noImageMsg.css('line-height'))) / 2;
                me.ui.noImageMsg.css('padding-top', topPadding);
            }

            const parentFn = RivalIQ.views.SocialPostGridItem.prototype.onAttach;
            return parentFn.apply(me, arguments);
        },

        className: function () {
            const me = this;

            const classes = ['social-post-grid-item', 'pointer'];
            if (RivalIQ.apps.SocialPosts.utils.isGridDetailsLayout(me)) {
                classes.push('expanded');
            }

            if (RivalIQ.apps.SocialPosts.utils.isGridSquareLayout(me)) {
                classes.push('fixed-dimensions');
                if (!me.dashboardModel.isExporting()) {
                    classes.push('lazy-load');
                }
            }

            const className = classes.join(' ');

            return className;
        },

        serializeData: function () {
            const me = this;
            const model = me.model;
            const data = model.toJSON();

            const channel = me.getProp('channel');
            const channelDetails = RivalIQ.data.channels.get(channel);
            const channelName = channelDetails.get('name');

            const videoUrl = RivalIQ.apps.SocialPosts.utils.makePreviewVideoUrl(data.rivaliq.display.video || data.video);
            const useCdnThumbnail = RivalIQ.apps.SocialPosts.utils.shouldUseCdnThumbnail(data.useThumbnailUrl, data.image);

            return _.defaults(_.omit(data, 'rivaliq'), {
                video: videoUrl,
                useCdnThumbnail: useCdnThumbnail
            }, data.rivaliq.display, {
                channel: me.getProp('channel'),
                channelName: channelName,
                isSquare: RivalIQ.apps.SocialPosts.utils.isGridSquareLayout(me),
                metric: me.getGridDetailMetric(),
                postLink: null,
                image: data.image || undefined
            }, App.utils.generateProfileLinks(data.user.handle, me.getProp('channel')), data);
        },

        getGridDetailMetric: function () {
            const me = this;

            const orderBy = App.utils.getOrderBy(me);
            let metricVal;
            if (orderBy.property === 'published_at') {
                const publishedAt = moment.utc(me.model.get(orderBy.property));
                metricVal = `${publishedAt.format('MMM D, YYYY')} ${publishedAt.format('LT')} UTC`;
            } else {
                metricVal = RivalIQ.formatter.formatAbbreviated(me.model.get(orderBy.property));
            }
            const metricName = RivalIQ.metric.names.metricName(orderBy);

            return {
                metricValue: metricVal,
                metricName: metricName || null
            };
        },

        onClick: function (e) {
            const me = this;
            // Links should not pop the modal
            if ($(e.target).is('a') || me.getProp('noClickThrough')) {
                return;
            }

            let sliceStart = 1;
            let sliceEnd = me.dashboardModel.metricsCollection.length;
            if (me.getProp('channel') === RivalIQ.enums.channels.TWITTER) {
                sliceStart = 2;
                // we don't want sentiment for twitter
                sliceEnd = sliceEnd - 1;
            } else if (me.getProp('searchType') === App.enums.searchTypes.PROFILE) {
                sliceStart = 2;
            }

            RivalIQ.execute('show:modal', {
                size: 'large',
                className: 'post-modal',
                information: {
                    title: 'Post Details',
                    content: RivalIQ.strings.social_post_details_info
                },
                contentView: new App.views.PostDetails({
                    model: me.model,
                    // grab the post metrics we want to show from metricsCollection
                    postDetailMetrics: _.map(_.slice(me.dashboardModel.metricsCollection.models, sliceStart, sliceEnd), 'attributes'),
                    channel: me.getProp('channel')
                })
            });
        }
    });

    // This is based on sortRow in dashboard/table.js, but the data has a slightly different shape here.
    function sortGridItem(orderByProperties, sortOrder, sortFunctions) {
        return function (a, b) {

            function sortByColumn(orderByProperty) {
                const valueA = a.get(orderByProperty);
                const valueB = b.get(orderByProperty);

                return sortFunctions[orderByProperty](valueA, valueB, sortOrder);
            }

            let idx = 0;
            let result = 0;
            while (_.exists(orderByProperties[idx]) && result === 0) {
                result = sortByColumn(orderByProperties[idx]);
                idx++;
            }

            return result;
        };
    }

    const DiscoveryPostGrid = RivalIQ.views.SocialPostGrid.extend({
        childView: DiscoveryPostGridItem,

        filter: function (child) {
            return _.get(child, ['attributes', 'rivaliq', 'display', 'image']) || _.get(child, ['attributes', 'rivaliq', 'display', 'video']);
        },

        getBaseMetric: function () {
            const me = this;

            const sortColumns = App.utils.getColumnSortOrder(me.dashboardModel.metricsCollection, me.getProp('orderBy'));
            me.orderByProperties = App.utils.getOrderByString(sortColumns, me.dashboardModel.metricsCollection);

            return _.defaults({
                property: 'post',
                orderBy: me.orderByProperties
            }, me.getProps(), me.dashboardModel.baseMetric);
        },

        loadData: function () {
            const me = this;

            const config = me.getBaseMetric();
            const definition = new RivalIQ.models.MetricDefinition(config);
            const limit = me.getProp('limit');

            return definition.fetch()
                .then(function (metric) {
                    let models = _.map(metric.getValue(), function (value) {
                        return _.last(value);
                    });

                    // sort the models.
                    const sortFunctions = me.dashboardModel.metricsCollection.reduce(function (memo, metric) {
                        memo[metric.get('property')] = metric.getSortFunction();
                        return memo;
                    }, {});

                    models = models.sort(sortGridItem(me.orderByProperties.split(','), me.getProp('sortOrder') || 1, sortFunctions));

                    if (limit > 0) {
                        const modelsWithMedia = [];
                        // build a collection of posts with media for us to show until we reach the widget limit
                        _.some(models, function (model) {
                            if (modelsWithMedia.length === limit) {
                                return true;
                            } else {
                                const riq = model.get('rivaliq');
                                const riqDisplayMedia = _.get(riq, ['display', 'image']) || _.get(riq, ['display', 'video']);
                                if (riqDisplayMedia) {
                                    modelsWithMedia.push(model);
                                }
                                return false;
                            }
                        });
                        me.collection.reset(modelsWithMedia, {
                            silent: true
                        });
                    } else {
                        me.collection.reset(models, {
                            silent: true
                        });
                    }
                });
        },

        emptyView: RivalIQ.views.ItemView.extend({
            className: 'grid-view-empty',
            template: '#discoveryPostGridNoPostsTemplate'
        })
    });

    const DiscoveryPostContainer = RivalIQ.views.SocialPostContainer.extend({
        onBeforeRenderLoaded: function () {
            const me = this;

            let View = TableView;
            if (RivalIQ.apps.SocialPosts.utils.isGridLayout(me)) {
                View = DiscoveryPostGrid;
            }

            me.container.show(new View(me.options));
        }
    });

    const DiscoveryPostGridSwitch = App.views.DiscoveryPostGridSwitch = RivalIQ.apps.SocialPosts.views.PostLayoutDropdown.extend({
        template: '#discoveryPostGridSwitchTemplate',

        onSelectDropdown: function (data) {
            const me = this;
            // don't need to set layout to undefined; widget defaults to list view in any unrecognized case
            const layout = data.itemId;
            _.defer(function () {
                me.setProps('layout', layout);
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangePostWidgetLayout, {
                channel: me.getProp('channel'),
                layout: layout,
                curationId: me.dashboardModel.getCuration().id
            });
        }
    });

    const SortDropdown = RivalIQ.apps.SocialPosts.views.SortDropdown.extend({
        template: '#socialPostsSortDropdownSmallTemplate',
        getMetrics: function () {
            const me = this;

            const channel = me.getProp('channel');

            let sortableProperties = [
                'published_at',
                'engagement_total'
            ];

            if (channel === RivalIQ.enums.channels.TWITTER) {
                sortableProperties = sortableProperties.concat([
                    'presence_reach',
                    'sentiment'
                ]);
            } else if ((channel === RivalIQ.enums.channels.INSTAGRAM) && (me.getProp('searchType') !== App.enums.searchTypes.PROFILE)) {
                // we don't have a published_at to sort by, so take it out
                _.remove(sortableProperties, _.matches('published_at'));
            }

            return _.map(sortableProperties, function (property) {
                return new RivalIQ.models.MetricDefinition({
                    channel: channel,
                    dataSource: 'discovery',
                    dimensions: ['channel', 'postId'],
                    property: property
                });
            });
        },

        onSelectDropdown: function (data) {
            const me = this;

            const metrics = me.getMetrics();
            const metric = me.dashboardModel.metricsCollection.find({
                property: metrics[data.itemId].get('property')
            });
            if (!metric) {
                return;
            }

            const orderBy = me.dashboardModel.metricsCollection.indexOf(metric);
            let sortOrder = data.groupId;
            if (sortOrder === 1) {
                sortOrder = undefined;
            }

            me.setProps({
                orderBy: orderBy,
                sortOrder: sortOrder
            });
        }
    });

    const DiscoveryPostsPanel = RivalIQ.apps.Dashboard.views.Panel.extend({
        initialize: function () {
            const me = this;
            const existingLayout = me.dashboardModel.curation.getProp('postsWidgetLayout');
            const inDetails = !_.get(me.model, ['instanceId']);

            // the layout dropdown handles this in details view
            if (existingLayout && !inDetails) {
                me.setProps('layout', existingLayout);
            }
        },

        // need to re-generate the export dropdown on props change since the grid views have
        // a different set of export options.
        dashboardModelEvents: {
            'change': 'showActions'
        },

        showActions: function () {
            const me = this;
            const inDetails = !_.get(me.model, ['instanceId']);

            me.actions.show(new DiscoveryPostGridSwitch({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: inDetails
            });

            if (inDetails) {
                const layout = me.getProp('layout');
                if (layout && layout !== 'list') {
                    me.actions.show(new SortDropdown({
                        dashboardModel: me.dashboardModel
                    }), {
                        preventDestroy: true
                    });
                }
            } else {
                me.showExportDropdown();
            }
        }
    });

    const DiscoveryPostsWidget = RivalIQ.apps.Dashboard.widgets.TableWidget.extend({
        footerView: RivalIQ.apps.Dashboard.views.PanelFooter,
        view: DiscoveryPostContainer,
        title: 'Most Engaging Posts',
        description: function () {
            const me = this;

            let id = 'discovery_most_engaging_posts_description';
            if (me.isFocus()) {
                id = 'discovery_most_engaging_posts_details_description';
            }

            return RivalIQ.str(id, (RivalIQ.apps.SocialPosts.utils.isGridLayout(me) ? 'image' : 'row'));
        },

        neverFilter: true,
        detailPanelView: DiscoveryPostsPanel,
        panelView: DiscoveryPostsPanel,

        tableClassName: function () {
            const me = this;

            if (!me.getProp('noClickThrough')) {
                return 'table-hover';
            }
        },

        exportFormats: RivalIQ.apps.SocialPosts.utils.gridExportFormats,

        viewMorePath: function () {
            const me = this;
            const layout = me.getProp('layout');
            return me.getPath({
                limit: -1,
                orderBy: me.getProp('orderBy'),
                sortOrder: me.getProp('sortOrder'),
                layout: layout ? layout : 'list'
            });
        },

        getFilename: App.utils.getExportFilename,
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        getExportWidthClass: function () {
            const me = this;

            // NOTE we must pass any value besides undefined in order to signal
            // that we don't want to use the normal HD export width class
            if (RivalIQ.apps.SocialPosts.utils.isGridSquareLayout(me)) {
                return '';
            }

            return me.curation.getExportWidthClass();
        },

        processProps: function (props) {
            const me = this;

            me.metric = RivalIQ.metric.build(props, _.clone(me.baseMetric));

            props = _.defaults(props, {
                limit: 8,
                orderBy: 3, // sort by engagement total
                sortOrder: 1, // descending
                showDescriptions: true
            });

            let metrics = [];
            if (props.channel === RivalIQ.enums.channels.TWITTER || (me.getProp('searchType') === App.enums.searchTypes.PROFILE)) {
                metrics = [{
                    header: {
                        className: 'post-published-timezone'
                    },
                    property: 'published_at',
                    cellView: function () {
                        return RivalIQ.views.metric.PublishedAt;
                    }
                }];
            }

            metrics = metrics.concat([{
                property: 'post',
                cellView: _.constant(PostTableCell),
                sortable: false
            }]);

            if (props.channel === RivalIQ.enums.channels.TWITTER) {
                metrics = metrics.concat([{
                    property: 'presence_reach'
                }, {
                    property: 'engagement_total'
                }, {
                    property: 'sentiment',
                    description: RivalIQ.strings.discovery_sentiment_description
                }]);
            } else {
                metrics = metrics.concat([{
                    property: 'engagement_total'
                }]);
            }

            me.metricsCollection = new RivalIQ.collections.MetricDefinitions(RivalIQ.metric.build(me.metric, metrics));

            const parentFn = RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.processProps;
            return parentFn.apply(me, arguments);
        },

        processExportProps: function (props, changed) {
            const me = this;

            props.limit = RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.getVisualExportLimit.call(me, props);

            return me.processProps(props, changed);
        },

        csvExportProps: function () {
            const me = this;

            return {
                type: 'discoveryDataGenerator',
                metric: me.getExportMetricDefinitions('csv'),
                includeDimensionColumn: false
            };
        },

        getExportMetricDefinitions: function (format) {
            const me = this;

            // NOTE we are overriding a particular column serializer to expand into several columns for CSV
            const compoundMetric = me.metricsCollection.findWhere({
                property: 'post'
            });
            const defaultSerializer = compoundMetric.serialize;

            compoundMetric.serialize = function (format) {
                if (format === RivalIQ.enums.exportFormat.CSV) {
                    return _.invokeMap([
                        compoundMetric.build({
                            property: 'presence_handle',
                            name: 'Handle'
                        }),
                        compoundMetric.build({
                            property: 'postLink',
                            name: 'Post Link'
                        }),
                        compoundMetric.build({
                            property: 'type',
                            name: 'Type'
                        }),
                        compoundMetric.build({
                            property: 'message',
                            name: 'Message'
                        }),
                        compoundMetric.build({
                            property: 'link',
                            name: 'Link'
                        }),
                        compoundMetric.build({
                            property: 'image',
                            name: 'Image'
                        })
                    ], 'serialize', format);
                } else {
                    return defaultSerializer.apply(compoundMetric, arguments);
                }
            };

            // NOTE flatten the nested metrics that get inserted via the serializer above
            const metrics = _.flatten(me.metricsCollection.invoke('serialize', format));

            const sortColumns = me.metricsCollection.getColumnSortOrder(me.getProp('orderBy'));
            const orderBy = me.metricsCollection.getOrderBy(sortColumns);

            return _.map(metrics, function (metric) {
                return _.extend(metric, {
                    orderBy: orderBy,
                    limit: -1
                });
            });
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.DISCOVERY_POST_TABLE, DiscoveryPostsWidget);

}, window.s, window.moment);
